"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.TITLEICON = exports.TITLEINPUT = exports.TITLEWRAPPER = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var TITLEWRAPPER = function TITLEWRAPPER(a) {
  return (0, _cxs["default"])({
    " > div": _objectSpread({}, a ? {} : {
      marginTop: "-8px",
      marginLeft: "3px"
    }),
    " > p": {
      margin: 0,
      fontSize: _vars.FONT_SIZES.large,
      lineHeight: "25px",
      minHeight: "25px"
    }
  });
};

exports.TITLEWRAPPER = TITLEWRAPPER;
var TITLEINPUT = (0, _cxs["default"])({
  cursor: "text",
  "> input": {
    fontWeight: _vars.FONT_WEIGHTS.medium,
    marginLeft: "12px",
    minHeight: "42px",
    height: "42px",
    borderBottom: "1px solid transparent",
    borderRadius: "0px",
    "::placeholder": {
      color: "".concat(_vars.COLOURS.mono.black)
    },
    ":hover": {
      opacity: .5,
      cursor: "text",
      borderBottom: "1px dashed ".concat(_vars.COLOURS.grey.nevada)
    },
    ":focus": {
      opacity: 1,
      borderBottom: "1px dashed ".concat(_vars.COLOURS.grey.nevada)
    }
  }
});
exports.TITLEINPUT = TITLEINPUT;
var TITLEICON = (0, _cxs["default"])({
  alignSelf: "flex-start",
  top: "30px",
  left: 0,
  position: "absolute"
});
exports.TITLEICON = TITLEICON;